import React from 'react';
import styled from 'styled-components';
import { COLORS } from 'apps/web_forms/utils/constants';
import PropTypes from 'prop-types';

const StyledErrorMessage = styled.div`
  .error-label {
    color: ${COLORS.red};
    margin-top: 0.5em;
    font-size: initial;
  }
`;

const ErrorMessage = ({ children, className, id }) => (
  <StyledErrorMessage>
    <p id={id} className={`error-label ${className}`}>
      {children}
    </p>
  </StyledErrorMessage>
);

ErrorMessage.propTypes = {
  children: PropTypes.string,
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
};

ErrorMessage.defaultProps = {
  children: '',
  className: '',
};

export default ErrorMessage;
